import React from "react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { RuangCbtDetail } from "@/types";
import { MoreHorizontal } from "lucide-react";
import useApiBaseUrl from "@/hooks/useApiBaseUrl";
import { Link } from "react-router-dom";

export default function Actions({ row }: { row: RuangCbtDetail }) {
  const { apiBaseUrl } = useApiBaseUrl();

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() =>
                window.open(
                  `${apiBaseUrl}/setting/ruang-cbt-detail/cetak-peserta-ruang?tanggal_cbt=${row.tanggal_cbt}&id_ref_ruang_cbt=${row.id_ref_ruang_cbt}&sesi=${row.sesi}`
                )
              }
            >
              Cetak Peserta Ruang
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Link
                to={`/panitia-smbjm/album-peserta?id_ref_ruang_cbt=${row.id_ref_ruang_cbt}&tanggal_cbt=${row.tanggal_cbt}&sesi=${row.sesi}`}
              >
                Cetak Album Peserta
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </React.Fragment>
  );
}
